/* eslint-disable */
export class LocationData {
    address1!: string;
    address2!: string;
    cityId?: number;
    zipCode!: string;
    cityName!: string;

    constructor(obj?: any) {
        if (!obj) {
            return;
        }
        this.address1 = obj.primaryAddress || obj.street;
        this.address2 = obj.primaryAddressStreetNumber || obj.streetNumber;
        this.cityId = obj.primaryAddressCityId || obj.cityId;
        this.zipCode = obj.primaryAddressZipCode || obj.zipCode;
        this.cityName = obj.cityName;
    }
}